import { BaseInitialState, State } from 'src/types'

export const unselectedState = { label: '未選択', value: 'unselected' }
export const unselectedStateWithPrice = { label: '未選択', value: 'unselected', price: 0 }
export const unselectedColorState = { label: '未選択', value: 'unselected', color: '#fff' }

export const baseInitialState: BaseInitialState = {
  // トップページのloading
  isLoading: false,
  backStyle: unselectedState,
  dominantArm: unselectedState,
  size: unselectedState,
  fingerGuardType: unselectedState,
  baseModel: {
    productNumber: '',
    imageUrl: '',
    dominantArm: 'unselected',
    position: '',
    size: 0,
    webParts: '',
    description: '',
    series: '',
    backStyle: '',
    imageWidth: 0,
    imageHeight: 0
  }
}

export const initialPersonalState = {
  userName: '',
  userNameKana: '',
  phoneNumber: '',
  mailAddress: '',
  league: '',
  position: '',
  remarks: ''
}

export const initialGloveImagesState = {
  front: '',
  rear: ''
}

export const initialEmbroideryState = {
  id: 0,
  typeFace: { label: '', value: '' },
  position: { label: '', value: '' },
  color: { label: '未選択', value: 'unselected', color: '' },
  shadowColor: { label: '未選択', value: 'unselected' },
  edgeColor: { label: '未選択', value: 'unselected' },
  content: ''
}

export const colorInitialState = {
  parts: { label: '全体', value: 'all' },
  all: unselectedColorState,
  catchFace: unselectedColorState,
  edge: unselectedColorState,
  lace: unselectedColorState,
  linings: unselectedColorState,
  hamidashi: unselectedColorState,
  listLiningsMaterial: unselectedColorState,
  stitch: { label: '未選択', value: 'unselected', color: '#eee' },
  web: unselectedColorState,
  web2: unselectedColorState,
  thumbHook: unselectedColorState,
  littleHook: unselectedColorState,
  listBelt: unselectedColorState,
  indexCover: unselectedColorState
}

// 投・内・外で使うカラー情報
// Yell-storyとかはこっちをみている
export const gloveColorInitialState = {
  thumbOut: unselectedColorState,
  thumbWeb: unselectedColorState,
  thumbRoot: unselectedColorState,
  indexWeb: unselectedColorState,
  indexMiddle: unselectedColorState,
  middleIndex: unselectedColorState,
  middleRing: unselectedColorState,
  ringMiddle: unselectedColorState,
  ringLittle: unselectedColorState,
  littleRing: unselectedColorState,
  littleOut: unselectedColorState
}

export const initialInfielderState: State = {
  ...baseInitialState,
  kinds: unselectedState,
  tanner: unselectedState,
  backLace: unselectedState,
  webParts: unselectedState,
  ...colorInitialState,
  ...gloveColorInitialState,
  mouton: unselectedState,
  atomsLabel: unselectedState,
  loopOfRingFinger: unselectedState,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

// 日本語用 / i18nを満たすためだけに定義。実際には使用しない
export const initialUsGloveState: State = {
  ...baseInitialState,
  kinds: unselectedState,
  tanner: unselectedState,
  backLace: unselectedState,
  webParts: unselectedState,
  loopOfRingFinger: unselectedState,
  ...colorInitialState,
  ...gloveColorInitialState,
  mouton: unselectedState,
  atomsLabel: unselectedState,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const emojiMatch =
  /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g

export const REQUEST_HEADERS = {
  headers: {
    // prettier-ignore
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json'
  }
}

export const watchFormDefaultValue = {
  defaultValues: {
    mailAddress: '',
    mailAddress2: ''
  }
}
